/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    headerSection: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        marginBottom: '8px',
        textAlign: 'left',
        maxWidth: '100%'
    },
    headerTitle: {
        fontSize: '14px',
        fontWeight: '600',
        fontStyle: 'normal',
        lineHeight: '20px',
        color: '#242424',
        padding: '12px 8px 2px 8px',
        maxWidth: '100%',
    },
    headerDescription: {
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '20px',
        color: tokens.colorNeutralForeground2,
        maxWidth: '100%',
        padding: '4px 8px 0px 8px'
    }
});
